import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const saveReplenishmentRequestView = {
  name: "saveReplenishmentRequestView" as const,
  input: z.object({ view: viewSchemas["replenishment-requests"] }),
  output: z.object({}),
};
